//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';

export interface ParamsType {
    requestBody: {
        aggregations: Record<string, string>;
        eventId: string;
        from: string;
        idv2: string;
        marketId?: null | undefined | string;
        page: number;
        perPage: number;
        selectionId?: null | undefined | string;
        tags: Array<string>;
        to: string;
        topics: Array<string>;
        type: string;
    };
}

const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/audit -> post -> ${code}`);
    };
};

export const Response200IO = t.interface({
    results: t.array(
        t.interface({
            body: t.interface({
                active: t.union([t.null, t.undefined, t.boolean]),
                autoTakeDown: t.union([t.null, t.undefined, t.boolean]),
                baseCashout: t.union([t.null, t.undefined, t.number]),
                betLimits: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        gradeType: t.union([t.null, t.undefined, t.string]),
                        liabilityLimit: t.union([t.null, t.undefined, t.number]),
                        maxBet: t.union([t.null, t.undefined, t.number]),
                        maxMultipleBet: t.union([t.null, t.undefined, t.number]),
                        maxWin: t.union([t.null, t.undefined, t.number]),
                    }),
                ]),
                blockSettlement: t.union([t.null, t.undefined, t.boolean]),
                bp: t.union([t.null, t.undefined, t.boolean]),
                cashoutAvailable: t.union([t.null, t.undefined, t.boolean]),
                cashoutEnabled: t.union([t.null, t.undefined, t.boolean]),
                cashoutOfferEasing: t.union([t.null, t.undefined, t.number]),
                cashoutOverround: t.union([t.null, t.undefined, t.number]),
                competition: t.interface({
                    id: t.union([t.null, t.undefined, t.string]),
                    name: t.union([t.null, t.undefined, t.string]),
                }),
                defaultStartingPrice: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        decimal: t.number,
                        fractional: t.string,
                    }),
                ]),
                display: t.union([t.null, t.undefined, t.boolean]),
                dividends: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        forecastDividend: t.union([
                            t.null,
                            t.undefined,
                            t.array(
                                t.interface({
                                    dividend: t.number,
                                    id: t.number,
                                    second: t.number,
                                    winner: t.number,
                                })
                            ),
                        ]),
                        tricastDividend: t.union([
                            t.null,
                            t.undefined,
                            t.array(
                                t.interface({
                                    dividend: t.number,
                                    id: t.number,
                                    second: t.number,
                                    third: t.number,
                                    winner: t.number,
                                })
                            ),
                        ]),
                    }),
                ]),
                eachWay: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        offered: t.union([t.null, t.undefined, t.boolean]),
                        terms: t.union([
                            t.null,
                            t.undefined,
                            t.array(
                                t.interface({
                                    places: t.union([t.null, t.undefined, t.number]),
                                    reduction: t.union([t.null, t.undefined, t.string]),
                                })
                            ),
                        ]),
                        termsWithBet: t.union([t.null, t.undefined, t.boolean]),
                    }),
                ]),
                eachWayStakeReduction: t.union([t.null, t.undefined, t.number]),
                event: t.interface({
                    feedId: t.union([t.null, t.undefined, t.string]),
                    id: t.union([t.null, t.undefined, t.string]),
                    name: t.union([t.null, t.undefined, t.string]),
                    platformId: t.union([t.null, t.undefined, t.string]),
                }),
                eventInPlaySettings: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        inPlayDelay: t.number,
                        tradedInPlay: t.boolean,
                    }),
                ]),
                feedSettings: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        eachWay: t.union([t.null, t.undefined, t.boolean]),
                        prices: t.union([t.null, t.undefined, t.boolean]),
                        results: t.union([t.null, t.undefined, t.boolean]),
                        updates: t.union([t.null, t.undefined, t.boolean]),
                    }),
                ]),
                forecastOffered: t.union([t.null, t.undefined, t.boolean]),
                gradeId: t.union([t.null, t.undefined, t.string]),
                gradeName: t.union([t.null, t.undefined, t.string]),
                gradeType: t.union([t.null, t.undefined, t.string]),
                id: t.union([t.null, t.undefined, t.string]),
                inPlayDelay: t.union([t.null, t.undefined, t.number]),
                incidents: t.union([
                    t.null,
                    t.undefined,
                    t.array(
                        t.interface({
                            bettable: t.string,
                            id: t.string,
                            period: t.string,
                            player: t.union([t.null, t.undefined, t.string]),
                            team: t.union([t.null, t.undefined, t.string]),
                            time: t.interface({
                                minutes: t.number,
                                seconds: t.number,
                            }),
                        })
                    ),
                ]),
                market: t.interface({
                    id: t.union([t.null, t.undefined, t.string]),
                    name: t.union([t.null, t.undefined, t.string]),
                    platformObjectId: t.union([t.null, t.undefined, t.string]),
                    uuid: t.union([t.null, t.undefined, t.string]),
                }),
                marketBetReferallEnabled: t.union([t.null, t.undefined, t.boolean]),
                marketType: t.union([t.null, t.undefined, t.string]),
                metaData: t.union([t.null, t.undefined, t.string]),
                name: t.union([t.null, t.undefined, t.string]),
                oldPrice: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        decimal: t.number,
                        fractional: t.string,
                    }),
                ]),
                participants: t.union([t.null, t.undefined, t.string]),
                price: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        decimal: t.number,
                        fractional: t.string,
                    }),
                ]),
                priceHistory: t.union([
                    t.null,
                    t.undefined,
                    t.array(
                        t.interface({
                            decimal: t.number,
                            fractional: t.string,
                        })
                    ),
                ]),
                priceType: t.union([t.null, t.undefined, t.string]),
                prices: t.union([t.null, t.undefined, t.boolean]),
                reductions: t.union([t.null, t.undefined, t.string]),
                result: t.union([t.null, t.undefined, t.string]),
                rule4: t.union([t.null, t.undefined, t.string]),
                selection: t.union([t.null, t.undefined, t.string]),
                selectionType: t.union([t.null, t.undefined, t.string]),
                selections: t.union([t.null, t.undefined, t.string]),
                settings: t.union([t.null, t.undefined, t.string]),
                singlesOnly: t.union([t.null, t.undefined, t.boolean]),
                source: t.union([t.null, t.undefined, t.string]),
                sp: t.union([t.null, t.undefined, t.boolean]),
                spOnly: t.union([t.null, t.undefined, t.boolean]),
                spPrice: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        decimal: t.number,
                        fractional: t.string,
                    }),
                ]),
                startDate: t.union([t.null, t.undefined, t.string]),
                startingPrice: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        decimal: t.number,
                        fractional: t.string,
                    }),
                ]),
                state: t.union([t.null, t.undefined, t.string]),
                statistics: t.union([t.null, t.undefined, t.string]),
                suspendTime: t.union([t.null, t.undefined, t.string]),
                timeSettings: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        offAtStartTime: t.union([t.null, t.undefined, t.boolean]),
                        startTime: t.union([t.null, t.undefined, t.string]),
                        started: t.union([t.null, t.undefined, t.boolean]),
                        timeZone: t.union([t.null, t.undefined, t.string]),
                        timeline: t.union([t.null, t.undefined, t.string]),
                        tradedInPlay: t.union([t.null, t.undefined, t.boolean]),
                    }),
                ]),
                tradedInPlay: t.union([t.null, t.undefined, t.boolean]),
                tricastOffered: t.union([t.null, t.undefined, t.boolean]),
                updates: t.union([t.null, t.undefined, t.boolean]),
            }),
            category: t.union([t.literal('EventChange'), t.literal('MarketChange'), t.literal('SelectionChange')]),
            id: t.number,
            observedAt: t.string,
            tags: t.union([t.null, t.undefined, t.string]),
            topic: t.string,
            type: t.string,
            universe: t.string,
            uuid: t.union([t.null, t.undefined, t.string]),
            when: t.string,
            who: t.interface({
                id: t.number,
                ip: t.union([t.null, t.undefined, t.string]),
                name: t.union([t.null, t.undefined, t.string]),
                type: t.union([t.null, t.undefined, t.string]),
            }),
        })
    ),
});
export type Response200Type = {
    results: Array<{
        body: {
            active?: null | undefined | boolean;
            autoTakeDown?: null | undefined | boolean;
            baseCashout?: null | undefined | number;
            betLimits?:
                | null
                | undefined
                | {
                      gradeType?: null | undefined | string;
                      liabilityLimit?: null | undefined | number;
                      maxBet?: null | undefined | number;
                      maxMultipleBet?: null | undefined | number;
                      maxWin?: null | undefined | number;
                  };
            blockSettlement?: null | undefined | boolean;
            bp?: null | undefined | boolean;
            cashoutAvailable?: null | undefined | boolean;
            cashoutEnabled?: null | undefined | boolean;
            cashoutOfferEasing?: null | undefined | number;
            cashoutOverround?: null | undefined | number;
            competition: {
                id?: null | undefined | string;
                name?: null | undefined | string;
            };
            defaultStartingPrice?:
                | null
                | undefined
                | {
                      decimal: number;
                      fractional: string;
                  };
            display?: null | undefined | boolean;
            dividends?:
                | null
                | undefined
                | {
                      forecastDividend?:
                          | null
                          | undefined
                          | Array<{
                                dividend: number;
                                id: number;
                                second: number;
                                winner: number;
                            }>;
                      tricastDividend?:
                          | null
                          | undefined
                          | Array<{
                                dividend: number;
                                id: number;
                                second: number;
                                third: number;
                                winner: number;
                            }>;
                  };
            eachWay?:
                | null
                | undefined
                | {
                      offered?: null | undefined | boolean;
                      terms?:
                          | null
                          | undefined
                          | Array<{
                                places?: null | undefined | number;
                                reduction?: null | undefined | string;
                            }>;
                      termsWithBet?: null | undefined | boolean;
                  };
            eachWayStakeReduction?: null | undefined | number;
            event: {
                feedId?: null | undefined | string;
                id?: null | undefined | string;
                name?: null | undefined | string;
                platformId?: null | undefined | string;
            };
            eventInPlaySettings?:
                | null
                | undefined
                | {
                      inPlayDelay: number;
                      tradedInPlay: boolean;
                  };
            feedSettings?:
                | null
                | undefined
                | {
                      eachWay?: null | undefined | boolean;
                      prices?: null | undefined | boolean;
                      results?: null | undefined | boolean;
                      updates?: null | undefined | boolean;
                  };
            forecastOffered?: null | undefined | boolean;
            gradeId?: null | undefined | string;
            gradeName?: null | undefined | string;
            gradeType?: null | undefined | string;
            id?: null | undefined | string;
            inPlayDelay?: null | undefined | number;
            incidents?:
                | null
                | undefined
                | Array<{
                      bettable: string;
                      id: string;
                      period: string;
                      player?: null | undefined | string;
                      team?: null | undefined | string;
                      time: {
                          minutes: number;
                          seconds: number;
                      };
                  }>;
            market: {
                id?: null | undefined | string;
                name?: null | undefined | string;
                platformObjectId?: null | undefined | string;
                uuid?: null | undefined | string;
            };
            marketBetReferallEnabled?: null | undefined | boolean;
            marketType?: null | undefined | string;
            metaData?: null | undefined | string;
            name?: null | undefined | string;
            oldPrice?:
                | null
                | undefined
                | {
                      decimal: number;
                      fractional: string;
                  };
            participants?: null | undefined | string;
            price?:
                | null
                | undefined
                | {
                      decimal: number;
                      fractional: string;
                  };
            priceHistory?:
                | null
                | undefined
                | Array<{
                      decimal: number;
                      fractional: string;
                  }>;
            priceType?: null | undefined | string;
            prices?: null | undefined | boolean;
            reductions?: null | undefined | string;
            result?: null | undefined | string;
            rule4?: null | undefined | string;
            selection?: null | undefined | string;
            selectionType?: null | undefined | string;
            selections?: null | undefined | string;
            settings?: null | undefined | string;
            singlesOnly?: null | undefined | boolean;
            source?: null | undefined | string;
            sp?: null | undefined | boolean;
            spOnly?: null | undefined | boolean;
            spPrice?:
                | null
                | undefined
                | {
                      decimal: number;
                      fractional: string;
                  };
            startDate?: null | undefined | string;
            startingPrice?:
                | null
                | undefined
                | {
                      decimal: number;
                      fractional: string;
                  };
            state?: null | undefined | string;
            statistics?: null | undefined | string;
            suspendTime?: null | undefined | string;
            timeSettings?:
                | null
                | undefined
                | {
                      offAtStartTime?: null | undefined | boolean;
                      startTime?: null | undefined | string;
                      started?: null | undefined | boolean;
                      timeZone?: null | undefined | string;
                      timeline?: null | undefined | string;
                      tradedInPlay?: null | undefined | boolean;
                  };
            tradedInPlay?: null | undefined | boolean;
            tricastOffered?: null | undefined | boolean;
            updates?: null | undefined | boolean;
        };
        category: 'EventChange' | 'MarketChange' | 'SelectionChange';
        id: number;
        observedAt: string;
        tags?: null | undefined | string;
        topic: string;
        type: string;
        universe: string;
        uuid?: null | undefined | string;
        when: string;
        who: {
            id: number;
            ip?: null | undefined | string;
            name?: null | undefined | string;
            type?: null | undefined | string;
        };
    }>;
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);

type ExtraHeadersType = Record<string, string>;

/**
 * @deprecated - Please use this method "openapiProxyStaffAuditEventRequest"
 */
export const openapi_proxy_staff_audit_event = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<FetchGeneralRawResponseType> => {
    const query = '';
    const url = `${api_url}/api-proxy/staff/audit${query}`;

    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};

export type OpenapiProxyStaffAuditEventParamsType = ParamsType;

export type OpenapiProxyStaffAuditEventResponseType =
    | {
          status: 200;
          body: Response200Type;
      }
    | {
          status: 400;
          body: Response400Type;
      }
    | {
          status: 401;
          body: Response401Type;
      }
    | {
          status: 500;
          body: Response500Type;
      };

export type OpenapiProxyStaffAuditEventResponse200Type = Response200Type;

export const openapiProxyStaffAuditEventRequest = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<OpenapiProxyStaffAuditEventResponseType> => {
    const response = await openapi_proxy_staff_audit_event(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffAuditEventRequest - unhandled response ${response.status}`);
};
